import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  width: 14px;\n  height: 14px;\n  min-width: 14px;\n  margin-right: 5px;\n'], ['\n  width: 14px;\n  height: 14px;\n  min-width: 14px;\n  margin-right: 5px;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../Icon';

var propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  value: PropTypes.string
};

var defaultProps = {
  color: 'default'
};

var LabelIcon = function (_PureComponent) {
  _inherits(LabelIcon, _PureComponent);

  function LabelIcon(props) {
    _classCallCheck(this, LabelIcon);

    var _this = _possibleConstructorReturn(this, (LabelIcon.__proto__ || Object.getPrototypeOf(LabelIcon)).call(this, props));

    _this.componentWillUnmount = function () {
      clearTimeout(_this.timeout);
    };

    _this.mouseEnter = function () {
      _this.setState({ hover: true, showText: true });
      clearTimeout(_this.timeout);
    };

    _this.mouseLeave = function () {
      _this.setState({ hover: false });
      _this.timeout = setTimeout(function () {
        _this.setState({ showText: false });
      }, 500);
    };

    _this.state = {
      hover: false,
      showText: false
    };
    return _this;
  }

  _createClass(LabelIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          className = _props.className,
          color = _props.color,
          value = _props.value;
      var _state = this.state,
          hover = _state.hover,
          showText = _state.showText;

      var finalClassName = 'gp-label-content' + (className ? ' ' + className : '') + (color ? ' ' + color : '') + (hover ? ' hover' : '');
      return React.createElement(
        'span',
        { className: 'gp-label', onMouseEnter: this.mouseEnter, onMouseLeave: this.mouseLeave },
        React.createElement(
          'span',
          { className: finalClassName },
          React.createElement(StyledIcon, { icon: icon, fill: 'white' }),
          value ? React.createElement(
            'span',
            { className: 'gp-label-text' },
            showText ? value : ''
          ) : ''
        )
      );
    }
  }]);

  return LabelIcon;
}(PureComponent);

LabelIcon.propTypes = propTypes;
LabelIcon.defaultProps = defaultProps;

export default LabelIcon;

var StyledIcon = styled(Icon)(_templateObject);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/LabelIcon/index.js
// module id = 824
// module chunks = 0